import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import PlusIcon from '../../images/icon-plus.svg';
import Navbar from '../../components/Navbar';
import DeleteVariationModal from '../../components/DeleteVariationModal';
import GenericVariationsList from '../../components/GenericVariationsList';
import * as styles from './style';
import withVariations from '../../containers/GlobalVariations';
import CreateVariationModal from '../../components/CreateVariationModal';

class GlobalVariations extends PureComponent {
  state = {
    showEditName: false,
    variations: [],
    categories: [],
    merchant: {},
    error: false,
    showLoader: true,
  };

  onSubmit = formData => {
    const { variationPersisted, createVariation, editVariation } = this.props;

    if (Object.keys(variationPersisted).length) {
      editVariation({ id: variationPersisted.id, ...formData });
    } else {
      createVariation(formData);
    }
  };

  componentDidMount() {
    this.props.getVariations();
  }

  render() {
    const { isLoadingVariations, variations } = this.props;

    const serializedVariations = variations.map(variation => ({
      ...variation,
      options: variation.options,
    }));

    return (
      <div>
        <Navbar
          button={
            <Button
              id="btn-add-variation"
              onClick={this.props.onClickVariationActions}
              customStyles={{
                padding: '10px 15px',
              }}
            >
              <img
                src={PlusIcon}
                alt="Ícone do botão de adicionar"
                style={{ marginRight: '10px' }}
              />
              Variação Global
            </Button>
          }
        />
        <styles.Content>
          <styles.Box>
            <GenericVariationsList
              id="select-variations"
              title="Variações Globais"
              desc={
                <span>
                  Você pode criar novas Variações Globais ou editá-las (as mudanças serão feitas em
                  todos os produtos que a Variação Global estiver atrelada)
                </span>
              }
              searchPlaceholder="Pesquisar Variações Globais"
              options={serializedVariations}
              isLoading={isLoadingVariations}
            />
          </styles.Box>
        </styles.Content>

        <DeleteVariationModal />

        <CreateVariationModal onSubmit={this.onSubmit} />
      </div>
    );
  }
}

GlobalVariations.propTypes = {
  variationPersisted: PropTypes.object,
  createVariation: PropTypes.func,
  editVariation: PropTypes.func,
};

export default withVariations(GlobalVariations);



// WEBPACK FOOTER //
// ./src/screens/GlobalVariations/index.js